import { render, staticRenderFns } from "./ReturnProduct.vue?vue&type=template&id=b47433ae&scoped=true"
import script from "./ReturnProduct.vue?vue&type=script&lang=js"
export * from "./ReturnProduct.vue?vue&type=script&lang=js"
import style0 from "./ReturnProduct.vue?vue&type=style&index=0&id=b47433ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47433ae",
  null
  
)

export default component.exports